// extracted by mini-css-extract-plugin
export var fileUpload = "_gv-1";
export var modalButton = "_gv-0";